__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => (typeof console !== "undefined" && console.warn && console.warn(msg));
	var uniqueName = "AustinEhsAudits";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@amzn/austin-core", "2.166.0", () => (Promise.all([__webpack_require__.e(4230), __webpack_require__.e(2345), __webpack_require__.e(1091), __webpack_require__.e(9459), __webpack_require__.e(6402), __webpack_require__.e(7597), __webpack_require__.e(8842), __webpack_require__.e(1448), __webpack_require__.e(4045), __webpack_require__.e(4822), __webpack_require__.e(424), __webpack_require__.e(8172), __webpack_require__.e(7073), __webpack_require__.e(336), __webpack_require__.e(5411), __webpack_require__.e(7879), __webpack_require__.e(7182), __webpack_require__.e(7253), __webpack_require__.e(2393), __webpack_require__.e(3535), __webpack_require__.e(8345)]).then(() => (() => (__webpack_require__("../node_modules/@amzn/austin-core/dist/index.js"))))));
			register("react-dom", "18.2.0", () => (Promise.all([__webpack_require__.e(1542), __webpack_require__.e(2850)]).then(() => (() => (__webpack_require__("../node_modules/react-dom/index.js"))))));
			register("react-router-6", "6.30.3", () => (Promise.all([__webpack_require__.e(6403), __webpack_require__.e(4935), __webpack_require__.e(7253)]).then(() => (() => (__webpack_require__("../node_modules/react-router/dist/index.js"))))));
			register("react-router-dom", "6.30.3", () => (Promise.all([__webpack_require__.e(6403), __webpack_require__.e(5783), __webpack_require__.e(7253), __webpack_require__.e(5540)]).then(() => (() => (__webpack_require__("../node_modules/react-router-dom/dist/index.js"))))));
			register("react", "18.2.0", () => (__webpack_require__.e(7378).then(() => (() => (__webpack_require__("../node_modules/react/index.js"))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};